import React from 'react';

const FormContext = React.createContext();
const StepContext = React.createContext();
const RepeatableContext = React.createContext();

export { FormContext, StepContext, RepeatableContext };
